import React from 'react'
import { Alert, Empty, Skeleton } from 'antd'
import { useParams } from 'react-router-dom'

import { useEmailsSubscriptions } from './hooks'
import { ProductSubscriptionsCard } from './productCard'

export const EmailsTab: React.FC = () => {
  const { clientID } = useParams()

  const { subscriptions, loading, loadError, savingId } =
    useEmailsSubscriptions(`${clientID}`)

  // при перезапросе после сохранения список уже есть — не мигаем скелетоном
  if (loading && !subscriptions.length) return <Skeleton active />

  if (loadError) return <Alert type="error" message={loadError} showIcon />

  if (!subscriptions.length) return <Empty description="No subscriptions" />

  return (
    <>
      {subscriptions.map((item) => (
        <ProductSubscriptionsCard
          key={item.id}
          item={item}
          saving={savingId === item.id}
        />
      ))}
    </>
  )
}
